import { render, staticRenderFns } from "./EmailDomainSettings.vue?vue&type=template&id=7ee10ce8&scoped=true"
import script from "./EmailDomainSettings.vue?vue&type=script&lang=js"
export * from "./EmailDomainSettings.vue?vue&type=script&lang=js"
import style0 from "./EmailDomainSettings.vue?vue&type=style&index=0&id=7ee10ce8&prod&scoped=true&lang=css"
import style1 from "./EmailDomainSettings.vue?vue&type=style&index=1&id=7ee10ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee10ce8",
  null
  
)

export default component.exports